export class MetaFeedConfig {
    _id?: string;
    payUnit: 'weekly' | 'hourly' | 'annual' = 'weekly';
    weeklyHoursPerJob: number = 37.5;
    weeksPerYear: number = 36;
    roleLabelOverrides: { [key: string]: string } = {};
    settingLabelOverrides: { [key: string]: string } = {};
    defaultHeroImageTemplate?: string;
    includeOnlyFeatured: boolean = false;
    minWeeklyPay?: number;
    brandName: string = 'EDU Healthcare';
    googleProductCategory: string = 'Job';
    siteUrl: string = 'https://www.eduhealthcare.com';
    feedCacheTtlSeconds: number = 600;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface HeroImageTemplateTextField {
    enabled: boolean;
    xPct: number;
    yPct: number;
    fontSize: number;
    fontWeight: number;
    color: string;
    align: 'left' | 'center' | 'right';
}

export class HeroImageTemplate {
    _id?: string;
    name: string = '';
    backgroundUrl: string = '';
    canvasWidth: number = 1200;
    canvasHeight: number = 630;
    priceField: HeroImageTemplateTextField = defaultTextField(35, 96);
    locationField: HeroImageTemplateTextField = defaultTextField(55, 48);
    roleField: HeroImageTemplateTextField = defaultTextField(72, 42);
    badgeField: HeroImageTemplateTextField = { ...defaultTextField(88, 32), enabled: false };
    isArchived: boolean = false;
    createdAt?: Date;
    updatedAt?: Date;
}

function defaultTextField(yPct: number, fontSize: number): HeroImageTemplateTextField {
    return { enabled: true, xPct: 50, yPct, fontSize, fontWeight: 700, color: '#FFFFFF', align: 'center' };
}
